
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.667.5c1.377 0 2.5 1.123 2.5 2.5v10c0 1.377-1.123 2.5-2.5 2.5H3.333a2.505 2.505 0 01-2.5-2.5V3c0-1.377 1.123-2.5 2.5-2.5zm.832 4.1l-7.021 4.916a.833.833 0 01-.857.06l-.099-.06L2.5 4.6 2.5 13a.84.84 0 00.73.827l.103.006h13.334A.838.838 0 0017.5 13V4.6zm-.832-2.433H3.333a.838.838 0 00-.744.461L10 7.816l7.411-5.188a.838.838 0 00-.744-.461z","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    